import styled from 'styled-components'

import { MULTIMAXI_SPLIT_MIN_ROW_HEIGHT } from '../constants'
import { Passage as _Passage, Vignette as _Vignette } from './Passages.styles'
import { palette } from '../styles/branding'

export const Passages = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 24px;
`
export const Passage = styled(_Passage)`
  flex-basis: ${(props) => 100 / props.limit}%;
  justify-content: flex-start;
  margin: 0;
  min-height: ${MULTIMAXI_SPLIT_MIN_ROW_HEIGHT}px;
  padding: 0 18px;
`
export const Vignette = styled(_Vignette)`
  border-radius: 6px;
  margin-right: 24px;
  width: 83px;
  & span {
    font-size: 36px;
    line-height: 13px;
  }
`
export const LineContainer = styled.div`
  flex: 1;
  min-width: 0;
  & p {
    margin: 0;
    color: ${(props) => (props.light ? palette.dark : palette.neutral4)};
  }
  & p:first-child {
    font-size: 32px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  & p:last-child {
    font-size: 24px;
  }
`
export const DepartureContainer = styled.div`
  padding-right: 16px;
`
export const NoPassages = styled.div`
  align-items: center;
  color: ${(props) => (props.light ? palette.dark : palette.neutral4)};
  display: flex;
  flex: 1;
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 28px;
  font-weight: 700;
  justify-content: center;
`
